export const isNumber = (number: any): number is number =>
  typeof number === 'number';

export const isUndefined = (value: any): value is undefined => {
  return typeof value === 'undefined';
};
